import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Button } from 'antd';

const ButtonGroup = Button.Group;

const StyledTitle = styled.span`
  margin-top: 2px;
  margin-right: 10px;
  float: left;
  font-size: ${p => p.fontSize}
  ${props =>
    props.isInverse &&
    css`
      color: #80cae1 !important;
    `}
`;

const StyledButton = styled(Button)`
  margin-left: ${props => props.standAlone ? '10px' : '0'} !important;
  box-shadow: none !important;
  height: 25px !important;
  width: 32px;
  padding: 2px;
  padding-top: 0;
  border-color: #5a687c !important;

  ${props =>
    props.active &&
    css`
      background: #5a687c !important;
      color: #fff !important;
    `}

  ${props =>
    props.isInverse &&
    css`
      border: none !important;
      background: rgb(0, 152, 204) !important;

      &:hover {
        background: #80cae1 !important;
      }
    `}

  ${props =>
    props.isInverse &&
    props.active &&
    css`
      background: #80cae1 !important;
    `}

  ${props =>
    props.small &&
    css`
      height: 18px !important;
      width: 22px;
      line-height: 15px !important;
    `}
`;

/**
 *
 * @param {title} string - Title that should come before the buttonGroup
 * @param {options} array - Array of options [
 *  {
 *    icon: fontawesome-icon to be used
 *    active: if button is active
 *    noGroup: true if button should be separated
 *    handler: function onClick
 *    activeSrc: image to be used when button is active (icon-option has priority)
 *    inActiveSrc: image to be used when button is inactive (icon-option has priority)
 *    small: use small buttons
 *  }
 * ]
 * @param {isInverse} bool - inverse styling. used when fullscreen
 */
const ButtonGroupComponent = ({
  title,
  options = [],
  isInverse = false,
  small = false,
  fontSize = '100%',
}) => {
  const renderIcon = (option) => {
    if (option.icon) {
      return <i className={`fas ${option.icon}`} />;
    }

    if (isInverse) {
      return <img src={option.activeSrc} />;
    }
    return <img src={option.active ? option.activeSrc : option.inActiveSrc} />;
  };

  return (
    <>
      {title && <StyledTitle isInverse={isInverse} fontSize={fontSize}>{`${title}: `}</StyledTitle>}
      <ButtonGroup>
        {options
          ?.filter(option => !option.noGroup)
          ?.map((option, key) =>
            <StyledButton
              key={key}
              active={option.active}
              isInverse={isInverse}
              onClick={option.handler}
              small={small}
            >
              {renderIcon(option)}
            </StyledButton>,
          )}
      </ButtonGroup>
      {options
        ?.filter(option => !!option.noGroup)
        ?.map((option, key) =>
          <StyledButton
            key={key}
            standAlone
            isInverse={isInverse}
            small={small}
            onClick={option.handler}
          >
            {renderIcon(option)}
          </StyledButton>,
        )}
    </>
  );
};

ButtonGroupComponent.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array.isRequired,
  isInverse: PropTypes.bool,
  small: PropTypes.bool,
  fontSize: PropTypes.string,
};

export default ButtonGroupComponent;
